// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zephr-onboarding-wizard__container-heading{padding:40px 0 20px;text-align:center}", "",{"version":3,"sources":["webpack://./src/components/onboarding-wizard/style.css"],"names":[],"mappings":"AAAA,4CACE,mBAAA,CACA,iBAAA","sourcesContent":[".zephr-onboarding-wizard__container-heading {\n  padding: 40px 0 20px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
